import { ComponentRoute } from '@/classes'

const OutstandingPartRoutes = {
  OutstandingPartListView: new ComponentRoute('/outstandingparts', 'OutstandingPartListView')
}

export default OutstandingPartRoutes
